<template>
  <div class="carriers-broker">
    <el-tabs v-model="activeTab" type="border-card">
      <el-tab-pane label="Quotes" name="quotes">
        <CarriersBrokerQuotes />
      </el-tab-pane>
      <slot v-if="isBroker">
        <el-tab-pane label="Performance" name="performance" lazy>
          <CarriersPerformance :modal="false" />
        </el-tab-pane>
        <el-tab-pane label="Warehouse Analysis" name="warehouse" lazy>
          <CarriersWarehouses />
        </el-tab-pane>
        <el-tab-pane label="Invitations" name="invitations" lazy>
          <CarriersBrokerInvitations />
        </el-tab-pane>
      </slot>
      <el-tab-pane v-if="isCarrierPartner" label="Profile" name="profile" lazy>
        <CarriersProfile :modal="false" :own="true" />
      </el-tab-pane>
    </el-tabs>
    <chat-popup />
  </div>
</template>
<script>
import CarriersBrokerQuotes from "@/default/pages/carriers/brokers/quotes.vue";
import CarriersBrokerInvitations from "@/default/pages/carriers/brokers/invitations.vue";
import CarriersPerformance from "@/default/pages/carriers/performance.vue";
import CarriersWarehouses from "@/default/pages/carriers/warehouses.vue";
import CarriersProfile from "@/default/pages/carriers/profile.vue";
export default {
  name: "CarriersBroker",
  components: {
    CarriersBrokerQuotes,
    CarriersBrokerInvitations,
    CarriersPerformance,
    CarriersWarehouses,
    CarriersProfile,
  },
  data() {
    return {
      activeTab: "quotes",
    };
  },
  mounted() {
    this.stopBack();
  },
};
</script>
<style lang="scss" scoped>
.carriers-broker {
  .el-tabs::v-deep {
    .el-tabs__content {
      @apply h-[calc(100vh_-_160px)] overflow-auto #{!important};
      overscroll-behavior-x: none;
    }
  }
}
</style>
